import React, { useContext } from 'react'
import { UseFormSetValue } from 'react-hook-form'
import { Flex, Radio } from 'pcln-design-system'
import BootstrapDataContext from '@/context/BootstrapDataContext'
import { swap } from '@/shared-utils/ramda-helper'
import { TripTypeInfos, TripTypeLabel } from './TripTypes'
import { PackagesFormStateType } from '../types'

const defaultTripTypes = Object.values(TripTypeInfos)
const mobileDefaultTripTypes = swap(1, 2, defaultTripTypes)

type TripTypeRadiosPropType = {
  setValue: UseFormSetValue<PackagesFormStateType>
  watchTripType: string
}

function TripTypeRadios({ setValue, watchTripType }: TripTypeRadiosPropType) {
  const { isMobile = false } = useContext(BootstrapDataContext)
  const tripTypes = isMobile ? mobileDefaultTripTypes : defaultTripTypes

  return (
    <Flex
      alignItems={['left', null, 'center']}
      flexDirection={['column', null, 'row']}
      justifyContent="space-between"
    >
      <Flex flexDirection="row" flexWrap="wrap">
        {tripTypes.map(typeInfo => (
          <Flex
            mr={[0, null, 3]}
            alignItems="center"
            key={typeInfo.id}
            width={isMobile ? 1 / 2 : 'auto'}
          >
            <TripTypeLabel fontSize={0} fontWeight={500} nowrap>
              <Radio
                id={typeInfo.id}
                type="radio"
                name="tripType"
                value={typeInfo.tripType}
                checked={watchTripType === typeInfo.tripType}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setValue('tripType', e.target.value, { shouldDirty: true })
                }}
              />{' '}
              {typeInfo.typeLabel}
            </TripTypeLabel>
          </Flex>
        ))}
      </Flex>
    </Flex>
  )
}

export default TripTypeRadios
